module.exports = __webpack_public_path__ + "static/media/resultats_XS.4dd7b8b0.pdf";